var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955",
    transform: "translate(1483 18523)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_356",
    "data-name": "Ellipse 356",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-1483 -18523)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_market_3792411",
    transform: "translate(-1472.98 -18513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(1.98 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M21.273,23.242h-.714V10.736a.714.714,0,1,0-1.428,0V23.242H15.563V17.357a.714.714,0,1,0-1.428,0v5.885H9.852V14.414a.714.714,0,1,0-1.428,0v8.828H4.855v-5.15a.714.714,0,1,0-1.428,0v5.15H2.714a.736.736,0,0,0,0,1.471H21.273a.736.736,0,0,0,0-1.471Z",
    transform: "translate(-1.987 -4.727)",
    fill: "#18beb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M19.839,2a2.168,2.168,0,0,0-1.88,1.025,1.842,1.842,0,0,0,.079,2.014l-2.526,3a2.221,2.221,0,0,0-2.154.448L11.248,7.51a1.93,1.93,0,0,0-1.07-1.961,2.278,2.278,0,0,0-2.371.173,1.884,1.884,0,0,0-.724,2.092L5.362,8.951a2.278,2.278,0,0,0-2.753.215,1.867,1.867,0,0,0-.235,2.542,2.253,2.253,0,0,0,2.674.643,1.932,1.932,0,0,0,1.138-2.325L7.906,8.889a2.257,2.257,0,0,0,2.71-.2l2.111.979a1.952,1.952,0,0,0,1.258,2.05,2.258,2.258,0,0,0,2.488-.524,1.855,1.855,0,0,0,.17-2.351l2.526-3A2.257,2.257,0,0,0,21.425,5.3,1.858,1.858,0,0,0,21.8,3.173,2.152,2.152,0,0,0,19.839,2Zm-15.7,9.227a.661.661,0,1,1,0-1.318.661.661,0,1,1,0,1.318Zm5-3.3a.661.661,0,1,1,.714-.659.688.688,0,0,1-.714.659Zm5.71,2.636a.661.661,0,1,1,.714-.659A.688.688,0,0,1,14.843,10.568Zm5-5.932a.688.688,0,0,1-.714-.659.716.716,0,0,1,1.428,0A.689.689,0,0,1,19.839,4.636Z",
    transform: "translate(-1.98 -2)",
    fill: "#18beb3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketIcon);
export default __webpack_public_path__ + "static/media/market-icon.274ea39b1526fab8eed57abca5372e65.svg";
export { ForwardRef as ReactComponent };